export const ALL_GAME_GUIDE_PAGE_TYPES = [
    'home',
    'texas',
    'omaha',
    'crazy-pineapple',
    'mixed-games',
    'power-player',
    'currencies',
    'hand-revealing',
    'four-color-deck',
    'auto-reload-chips',
    'mobile-device-support',
    'avatar-editor',
    'bombs',
    'bomb-ammo-display',
    'themes',
    'chat-commands',
    'bomb-chat-commands',
    'key-combos',
    'player-blocking',
    'aggro-betting-filter',
    'rabbit-hunting',
    'rules',
    'play-style',
    'how-its-built',
    'auto-betting',
    'medals',
    'royal-flush-club-medal',
    'hands-played-medal',
    'chips-medal',
    'insomniac-medal',
    'side-bets-won-medal',
    'side-bets-profit-medal',
    'piggy-medal',
    'cards-in-space-medal',
    'unique-avatars',
    'bad-beat-jackpot',
    'all-insanity',
    'side-bets',
    'betting-limit-types'
];
export function isGameGuidePageType(str) {
    if (!str) {
        return false;
    }
    return ALL_GAME_GUIDE_PAGE_TYPES.includes(str);
}
